export function hasViewVisitNotePermission(permissions) {
	return permissions.find(p => p === 'view-visit-notes');
}

export function hasCreatePatientPermission(permissions) {
	return permissions.find(p => p === 'create-patient');
}

export function hasViewANCNotePermission(permissions) {
	return permissions.find(p => p === 'view-antenatal-notes');
}

export function hasBillPermission(permissions) {
	return permissions.find(p => p === 'bill-patient');
}

export function hasViewPatientRecordsPermission(permissions) {
	return permissions.find(p => p === 'view-patient-records');
}

export function hasViewPatientHistoryPermission(permissions) {
	return permissions.find(p => p === 'view-patient-history');
}

export function hasViewPatientRequestsPermission(permissions) {
	return permissions.find(p => p === 'view-patient-requests');
}

export function hasViewBillablesPermission(permissions) {
	return permissions.find(p => p === 'view-billables');
}

export function hasViewClinicalRecordsPermission(permissions) {
	return permissions.find(p => p === 'view-clinical-records');
}

export function hasViewPatientProfilePermission(permissions) {
	return permissions.find(p => p === 'view-patient-profile');
}
